var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warning\"><g><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M15.936 2.5L21.5 8.067v7.87L15.936 21.5h-7.87L2.5 15.936v-7.87L8.066 2.5h7.87zm-.829 2H8.894L4.501 8.895v6.213l4.393 4.394h6.213l4.394-4.394V8.894l-4.394-4.393zM11 15h2v2h-2v-2zm0-8h2v6h-2V7z\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id